/** Eviction drops cache references; callers can keep using a value they hold. */
export class ByteLruCache<K, V> {
  readonly #entries = new Map<K, { value: V; bytes: number }>();
  #bytes = 0;

  constructor(readonly maxBytes: number, readonly weight: (value: V) => number, readonly maxEntries = 256) {}

  get size(): number { return this.#entries.size; }
  get bytes(): number { return this.#bytes; }

  get(key: K): V | undefined {
    const entry = this.#entries.get(key);
    if (!entry) return undefined;
    this.#entries.delete(key);
    this.#entries.set(key, entry);
    return entry.value;
  }

  set(key: K, value: V): void {
    const previous = this.#entries.get(key);
    if (previous) { this.#bytes -= previous.bytes; this.#entries.delete(key); }
    const bytes = this.weight(value);
    if (bytes > this.maxBytes) return;
    this.#entries.set(key, { value, bytes });
    this.#bytes += bytes;
    for (const [oldKey, entry] of this.#entries) {
      if (this.#bytes <= this.maxBytes && this.size <= this.maxEntries) break;
      this.#bytes -= entry.bytes;
      this.#entries.delete(oldKey);
    }
  }
}
